import { isRequestErrorWithCode } from '@swf/core/errors/RequestError';

const getErrorCode = (error: unknown): string =>
  isRequestErrorWithCode(error) ? error.body.code : '0';

export default getErrorCode;
